var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGothamBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("font", {
    id: "Gotham-Book_svg__Gotham-Book",
    horizAdvX: 790
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "Gotham Book",
    fontWeight: 400,
    ascent: 800,
    bbox: "-21 -163 1063 901",
    capHeight: 700,
    descent: -200,
    underlinePosition: -100,
    underlineThickness: 50,
    unicodeRange: "U+0020-00FE",
    xHeight: 517
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "space",
    horizAdvX: 300
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M114 198L91 643v57h90v-57l-24-445h-43zM90 0v105h92V0H90z",
    glyphName: "exclam",
    horizAdvX: 271,
    unicode: "!"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M260 428l31 272h92v-5l-81-267h-42zm-195 0l30 272h93v-5l-81-267H65z",
    glyphName: "quotedbl",
    horizAdvX: 440,
    unicode: "\""
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M615 246v-69H485L455 0h-70l30 177H224L194 0h-70l30 177H45v69h121l36 212H84v69h130l30 173h70l-30-173h191l30 173h70l-30-173h109v-69H533l-36-212h118zM273 459l-37-214h190l37 214H273z",
    glyphName: "numbersign",
    horizAdvX: 700,
    unicode: "#"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M547 618l-43-60q-74 60-151 72V383q162-38 201-118 15-34 15-76v-1q0-97-87-151Q428 5 356 0v-98h-64V2Q164 14 56 105l45 60q92-84 194-96v250Q138 356 99 434q-17 35-17 80v1q0 90 78 144 56 38 132 41v58h64v-60q99-12 191-80zm-55-435v1q0 59-51 90-32 18-88 33V66q96 6 128 68 11 23 11 49zM159 520v-1q0-61 56-93 31-17 80-30v237q-86-3-121-60-15-25-15-53z",
    glyphName: "dollar",
    horizAdvX: 636,
    unicode: "$"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M210 350q-82 0-128 72-30 47-30 105v2q0 88 60 141 43 38 100 38 80 0 126-71 31-47 31-106v-2q0-88-59-141-44-38-100-38zm0 302q-54 0-79-58-12-29-12-63v-2q0-70 45-106 22-17 48-17 52 0 78 56 13 30 13 65v2q0 70-45 106-23 17-48 17zm184-287l244 335h71L439 333 196 0h-72zM622-8q-80 0-126 71-31 47-31 106v2q0 88 59 141 44 38 100 38 83 0 128-73 29-47 29-104v-2q0-88-59-141Q679-8 622-8zm2 56q54 0 79 58 12 29 12 63v2q0 70-45 106-22 17-48 17-52 0-78-56-13-30-13-65v-2q0-70 45-106 22-17 48-17z",
    glyphName: "percent",
    horizAdvX: 834,
    unicode: "%"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M604-14L494 99Q392-10 265-10 150-10 88 64q-43 52-43 122v2q2 135 169 202-63 73-69 134-1 10-1 20v2q0 84 68 132 50 34 117 34 88 0 137-64 33-42 33-94v-2q-2-124-165-182l160-163q46 67 84 156l65-30q-52-111-101-176L664 32zM290 415q134 48 135 133v2q0 59-49 85-23 12-50 12-67 0-94-52-12-23-12-49v-2q0-48 46-102 11-13 24-27zM271 57q93 1 175 91L259 341q-129-56-134-150v-2q0-71 60-109 38-23 86-23z",
    glyphName: "ampersand",
    horizAdvX: 696,
    unicode: "&"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M65 428l30 272h94v-5l-81-267H65z",
    glyphName: "quotesingle",
    horizAdvX: 245,
    unicode: "'"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M378-90l-33-51Q69 15 68 287v1q1 272 277 427l33-51Q168 531 148 332q-2-23-2-45v-1q1-231 232-376z",
    glyphName: "parenleft",
    horizAdvX: 434,
    unicode: "("
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M89-141L56-90Q266 43 286 242q2 23 2 45v1q-1 231-232 376l33 51q276-156 277-428v-1Q365 14 89-141z",
    glyphName: "parenright",
    horizAdvX: 434,
    unicode: ")"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M189 397l10 125-103-73-27 47 116 53-116 54 27 46 103-72-10 125h52l-10-125 103 72 27-46-116-54 116-53-27-47-103 73 10-125h-52z",
    glyphName: "asterisk",
    horizAdvX: 430,
    unicode: "*"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M275 110v206H68v72h207v206h75V388h207v-72H350V110h-75z",
    glyphName: "plus",
    horizAdvX: 625,
    unicode: "+"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M58-122L46-87q63 24 67 69 1 9 0 18H77v105h92V15q0-93-71-124-18-8-40-13z",
    glyphName: "comma",
    horizAdvX: 245,
    unicode: ","
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M65 260v81h278v-81H65z",
    glyphName: "hyphen",
    horizAdvX: 408,
    unicode: "-"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M76 0v105h92V0H76z",
    glyphName: "period",
    horizAdvX: 244,
    unicode: "."
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-21-128l464 926h71L50-128h-71z",
    glyphName: "slash",
    horizAdvX: 508,
    unicode: "/"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M357-12q-138 0-222 115-73 102-73 245v2q0 158 87 262 84 99 210 100 137 0 220-114 74-102 74-246v-2q0-158-87-262-83-99-209-100zm2 72q105 0 166 103 46 79 46 185v2q0 133-70 218-60 71-144 72-104 0-165-101-48-80-48-187v-2q0-133 70-218 60-71 145-72z",
    glyphName: "zero",
    horizAdvX: 715,
    unicode: 0
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M179 0v623L47 582l-19 64 171 59h58V0h-78z",
    glyphName: "one",
    horizAdvX: 358,
    unicode: 1
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M48 0v61l254 224q109 98 134 157 12 30 12 63 0 76-64 114-35 20-77 20-86 0-153-76-17-19-35-44l-58 42q66 96 134 126 51 23 118 23 111 0 173-74 44-53 44-124v-2q0-86-65-163-36-43-112-109L166 72h371V0H48z",
    glyphName: "two",
    horizAdvX: 599,
    unicode: 2
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M311-12Q145-11 50 113l57 51Q193 60 312 60q85 0 128 58 25 34 25 78v2q0 85-92 119-45 16-104 16h-45l-16 47 221 249H87v71h447v-58L314 398q153-14 207-105 24-40 24-92v-2q0-104-84-165-64-46-150-46z",
    glyphName: "three",
    horizAdvX: 613,
    unicode: 3
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M432 0v166H63l-20 57 396 482h69V232h109v-66H508V0h-76zM138 232h294v361z",
    glyphName: "four",
    horizAdvX: 671,
    unicode: 4
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M303-12Q164-11 53 99l52 57q98-95 199-96 94 0 141 66 28 39 28 89v2q0 82-72 122-45 25-102 25-76 0-147-40l-53 35 20 341h403v-73H188l-15-224q68 31 138 31 125 0 193-78 49-56 49-136v-2q0-118-90-183-67-47-160-47z",
    glyphName: "five",
    horizAdvX: 612,
    unicode: 5
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M333-12q-113 1-184 71-71 71-84 194-4 35-4 77v2q0 184 93 291 79 89 198 89 112-1 207-80l-46-61q-82 69-165 69-111 0-167-115-39-79-39-185v-10q76 107 200 108 116 0 186-73 56-59 56-142v-2q0-110-85-178-71-55-166-55zm1 70q95 0 142 70 27 40 27 90v2q0 78-66 121-46 29-105 29-92 0-144-66-31-40-31-87v-2q0-81 68-126 47-31 109-31z",
    glyphName: "six",
    horizAdvX: 647,
    unicode: 6
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M137 0l316 628H68v72h475v-59L225 0h-88z",
    glyphName: "seven",
    horizAdvX: 596,
    unicode: 7
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M315-10q-133 0-209 73-54 53-54 125v2q0 108 121 163 12 5 23 9Q77 418 76 523v2q0 87 83 141 68 44 156 44 112 0 184-65 54-52 55-120v-2q-1-106-120-161 120-45 140-136 4-18 4-35v-2q0-98-92-155-72-44-171-44zm0 400q88 0 134 55 26 33 26 73v2q0 63-64 98-42 23-96 23-91 0-136-55-24-30-24-66v-2q0-70 68-106 41-22 92-22zm0-331q111 0 160 64 23 31 23 67v2q0 67-70 106-50 27-113 27-98 0-151-56-32-34-32-77v-2q0-67 67-104 48-27 116-27z",
    glyphName: "eight",
    horizAdvX: 630,
    unicode: 8
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M297 60q108 0 166 109 42 79 42 183v14q-73-110-198-111-127 0-196 81-48 58-48 136v2q0 111 82 180 70 58 170 58 112-1 184-72 87-88 87-271v-2q0-185-96-292-80-87-195-87-106 0-205 77-6 5-11 9l46 61q84-75 172-75zm19 263q95 0 145 70 29 40 29 88v2q0 80-67 126-48 33-111 33-95 0-142-73-26-41-26-91v-2q0-83 70-126 44-27 102-27z",
    glyphName: "nine",
    horizAdvX: 647,
    unicode: 9
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M81 412v105h92V412H81zM81 0v105h92V0H81z",
    glyphName: "colon",
    horizAdvX: 254,
    unicode: ":"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M82 412v105h92V412H82zM63-122L51-87q63 24 67 69 1 9 0 18H82v105h92V15q0-93-71-124-18-8-40-13z",
    glyphName: "semicolon",
    horizAdvX: 255,
    unicode: ";"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M534 86L64 319v66l470 233v-77L148 353l386-189V86z",
    glyphName: "less",
    horizAdvX: 625,
    unicode: "<"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M80 432v74h465v-74H80zm0-234v74h465v-74H80z",
    glyphName: "equal",
    horizAdvX: 625,
    unicode: "="
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M92 86v77l385 188L92 540v78l469-233v-66z",
    glyphName: "greater",
    horizAdvX: 625,
    unicode: ">"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M220 198l-15 162 5 5q154 4 190 92 9 23 9 49v2q0 72-61 108-37 22-85 22-102-1-182-94l-51 49q97 115 235 116 122 0 185-80 39-51 39-118v-2q0-130-126-182-38-15-82-21l-10-108h-51zM199 0v105h92V0h-92z",
    glyphName: "question",
    horizAdvX: 537,
    unicode: "?"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M499-162q-180 0-307 117Q72 65 55 227q-2 24-2 47 0 166 110 291 109 122 270 143 29 4 58 4 172 0 298-109 115-99 135-238 3-25 3-49 0-152-91-215-44-30-96-30-101 0-136 74-2 6-4 10-71-83-165-84-90 0-142 67-37 49-37 115 0 109 81 185 69 64 150 64 100-1 146-83l13 69 67-9-40-227q-7-39-7-61 0-69 65-80 10-1 20-1 71 0 110 70 30 55 30 136 0 128-96 231-102 111-255 128-25 3-49 3-163 0-278-111Q102 461 90 307q-1-17-1-33Q89 111 197-3q111-118 282-125h20q129 0 242 64 4 2 7 4l16-27q-124-75-265-75zm-49 295q60 1 108 48 56 57 56 132 0 71-55 107-30 20-67 20-61-1-110-49-54-56-54-133 0-86 67-115 25-10 55-10z",
    glyphName: "at",
    horizAdvX: 980,
    unicode: "@"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613z",
    glyphName: "A",
    unicode: "A"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h298q119-1 183-62 45-47 45-112v-2q-1-113-111-162 149-45 150-169v-2q0-111-104-161Q497 0 410 0H99zm446 513v2q0 77-80 103-33 11-75 11H177V388h207q117 0 151 73 10 24 10 52zm39-317v2q0 92-115 114-32 6-71 6H177V71h235q125 0 161 73 11 24 11 52z",
    glyphName: "B",
    horizAdvX: 722,
    unicode: "B"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M419-12Q269-12 168 93 68 197 68 348v2q0 148 97 252 107 107 257 110 143 0 244-85 15-12 29-26l-54-58q-89 84-185 94-17 2-35 2-122 0-201-91-70-82-70-196v-2q0-130 86-214 77-75 185-75 106 0 194 73 16 13 32 28l52-51Q596 5 468-9q-24-3-49-3z",
    glyphName: "C",
    horizAdvX: 742,
    unicode: "C"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h243q170 0 276-107 96-98 96-241v-2q0-150-105-250Q503 0 342 0H99zm243 627H178V73h164q148 0 229 98 61 74 61 177v2q0 129-90 208-81 69-200 69z",
    glyphName: "D",
    horizAdvX: 782,
    unicode: "D"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h506v-72H178V389h382v-72H178V72h432V0H99z",
    glyphName: "E",
    horizAdvX: 670,
    unicode: "E"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h503v-73H178V377h379v-72H178V0H99z",
    glyphName: "F",
    horizAdvX: 656,
    unicode: "F"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M424-12q-171 0-271 117-85 100-85 243v2q0 145 93 249 103 112 258 113 137 0 234-72 14-10 27-21l-51-60q-94 78-213 80-121 0-198-93-68-82-68-194v-2q0-143 92-225 75-66 185-66t195 64q4 4 7 6v174H416v71h289V95Q591-8 434-12h-10z",
    glyphName: "G",
    horizAdvX: 784,
    unicode: "G"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h79V389h404v311h79V0h-79v315H178V0H99z",
    glyphName: "H",
    horizAdvX: 760,
    unicode: "H"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 0v700h79V0h-79z",
    glyphName: "I",
    horizAdvX: 291,
    unicode: "I"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M247-10Q107-9 31 114l57 49q53-81 118-96 20-4 42-4 86 0 120 78 17 39 17 90v469h80V232q-1-120-64-184-60-58-154-58z",
    glyphName: "J",
    horizAdvX: 553,
    unicode: "J"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h79V282l402 418h103L382 394 695 0h-99L327 339 178 188V0H99z",
    glyphName: "K",
    horizAdvX: 719,
    unicode: "K"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h79V73h394V0H99z",
    glyphName: "L",
    horizAdvX: 615,
    unicode: "L"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h80l255-382 255 382h80V0h-79v567L435 192h-4L176 566V0H99z",
    glyphName: "M",
    horizAdvX: 868,
    unicode: "M"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h74l441-561v561h77V0h-63L176 574V0H99z",
    glyphName: "N",
    unicode: "N"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M424-12Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "O",
    horizAdvX: 850,
    unicode: "O"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h262q152 0 221-91 41-55 41-131v-2q0-128-110-190-71-39-165-39H178V0H99zm79 319h173q115 0 166 70 26 37 26 84v2q0 105-100 139-39 13-88 13H178V319z",
    glyphName: "P",
    horizAdvX: 668,
    unicode: "P"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M791 38l-54-59-93 83q-95-74-220-74-159 0-261 111-95 104-95 249v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q-1-134-83-234zM426 61q91 1 161 51L457 225l53 59 131-119q59 78 59 183v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "Q",
    horizAdvX: 850,
    unicode: "Q"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h301q129-1 199-70 54-55 54-138v-2q0-122-107-177-38-19-83-27L678 0h-97L378 272H178V0H99zm79 343h215q107 0 155 65 25 34 25 79v2q0 95-94 126-38 12-85 12H178V343z",
    glyphName: "R",
    horizAdvX: 723,
    unicode: "R"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M339-10Q176-9 53 102l49 58q96-88 205-97 17-2 35-2 98 0 138 60 18 27 18 59v2q0 58-50 88-42 25-132 45-160 35-207 103-28 40-28 99v2q0 92 80 147 63 44 150 44 128 0 227-71 10-8 19-15l-46-61q-94 76-202 76-94 0-133-58-16-25-16-55v-2q0-60 51-90 44-26 139-46 168-38 210-118 18-35 18-80v-2q0-105-91-160-62-38-148-38z",
    glyphName: "S",
    horizAdvX: 640,
    unicode: "S"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M281 0v627H45v73h551v-73H360V0h-79z",
    glyphName: "T",
    horizAdvX: 641,
    unicode: "T"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M379-11q-163 0-240 113-51 77-51 191v407h79V298q0-165 114-217 44-19 100-19 142 0 190 114 21 50 21 117v407h79V299q0-195-131-271-68-39-161-39z",
    glyphName: "U",
    horizAdvX: 759,
    unicode: "U"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M340-5L39 700h88L376 97l250 603h85L410-5h-70z",
    glyphName: "V",
    horizAdvX: 750,
    unicode: "V"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M295-5L45 700h86l200-583 192 585h65l192-585 200 583h83L813-5h-67L554 563 361-5h-66z",
    glyphName: "W",
    horizAdvX: 1107,
    unicode: "W"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M577 700h92L411 357 679 0h-94L361 302 137 0H46l268 357L56 700h93l214-288z",
    glyphName: "X",
    horizAdvX: 725,
    unicode: "X"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M318 0v277L27 700h96l236-350 238 350h92L398 278V0h-80z",
    glyphName: "Y",
    horizAdvX: 716,
    unicode: "Y"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M67 0v53l453 576H82v71h546v-53L174 71h454V0H67z",
    glyphName: "Z",
    horizAdvX: 693,
    unicode: "Z"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M94-130v830h286v-60H167V-70h213v-60H94z",
    glyphName: "bracketleft",
    horizAdvX: 439,
    unicode: "["
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M458-128L-6 798h71l464-926h-71z",
    glyphName: "backslash",
    horizAdvX: 508,
    unicode: "\\\\\\\\"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M59-130v60h214v710H59v60h286v-830H59z",
    glyphName: "bracketright",
    horizAdvX: 439,
    unicode: "]"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M65 493l155 209h60l155-209h-68L249 647 131 493H65z",
    glyphName: "asciicircum",
    horizAdvX: 500,
    unicode: "^"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-2-160v63h604v-63H-2z",
    glyphName: "underscore",
    horizAdvX: 600,
    unicode: "_"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M258 595L144 703l80 37 94-145h-60z",
    glyphName: "grave",
    horizAdvX: 500,
    unicode: "`"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13z",
    glyphName: "a",
    horizAdvX: 579,
    unicode: "a"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M361-11Q237-10 163 99V0H86v730h77V413q82 114 198 115 103 0 175-75 72-77 72-193v-2q0-135-93-213-68-56-154-56zm-14 69q93 0 145 72 37 53 37 127v2q0 110-76 166-47 34-106 34-82 0-138-65-49-57-49-134v-2q0-101 74-160 51-40 113-40z",
    glyphName: "b",
    horizAdvX: 664,
    unicode: "b"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M319-12q-119 0-197 87-68 78-68 181v2q0 117 82 197 76 73 183 73 117 0 201-86 4-3 6-6l-51-54q-65 68-132 77-13 1-25 1-90 0-144-73-41-55-41-127v-2q0-97 69-156 52-45 121-45 87 1 158 77l49-46Q447-7 334-12h-15z",
    glyphName: "c",
    horizAdvX: 571,
    unicode: "c"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M303-11q-103 0-175 75-72 77-72 193v2q0 135 94 213 68 56 153 56 124-1 198-110v312h77V0h-77v104Q420-10 303-11zm14 69q82 0 139 65 48 57 48 135v2q0 101-75 159-51 40-112 40-93 0-145-72-37-53-37-127v-2q0-110 76-166 47-34 106-34z",
    glyphName: "d",
    horizAdvX: 664,
    unicode: "d"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M312-12q-115 0-190 83-68 76-68 186v2q0 123 81 201 70 68 167 68 128 0 195-103 46-72 46-170 0-17-1-25H132q10-107 92-152 41-23 90-23 92 1 163 73l48-43Q446-5 332-11q-10-1-20-1zM132 287h333q-9 106-79 152-37 24-86 24-86 0-135-78-27-43-33-98z",
    glyphName: "e",
    horizAdvX: 592,
    unicode: "e"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M115 0v449H44v67h71v45q1 88 45 133 41 40 111 40 49 0 85-13v-67q-46 13-75 13-89-2-90-110v-42h164v-66H192V0h-77z",
    glyphName: "f",
    horizAdvX: 367,
    unicode: "f"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M315-162q-132 1-235 72l35 60q93-66 199-66 130 0 172 97 16 38 16 87v61Q419 41 299 40q-103 0-175 72-68 70-68 170v2q0 122 91 192 67 52 152 52 122-1 202-104v93h77V90q-1-117-66-183-70-69-197-69zm-1 270q87 0 144 61 46 49 46 114v2q0 90-76 141-51 34-114 34-93 0-144-66-35-46-35-108v-2q0-90 72-142 48-34 107-34z",
    glyphName: "g",
    horizAdvX: 664,
    unicode: "g"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v730h77V427q64 100 177 101 117 0 169-90 29-50 29-117V0h-77v302q0 111-80 145-29 11-63 11-85 0-128-67-27-41-27-95V0H86z",
    glyphName: "h",
    horizAdvX: 616,
    unicode: "h"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M88 630v85h88v-85H88zM93 0v517h77V0H93z",
    glyphName: "i",
    horizAdvX: 263,
    unicode: "i"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M88 630v85h88v-85H88zM44-163q-27 0-48 5v63q13-3 38-3 55 8 59 69v546h77V-30q-2-132-126-133z",
    glyphName: "j",
    horizAdvX: 263,
    unicode: "j"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v730h77V226l279 291h96L321 295 545 0h-92L268 241 163 135V0H86z",
    glyphName: "k",
    horizAdvX: 569,
    unicode: "k"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M93 0v730h77V0H93z",
    glyphName: "l",
    horizAdvX: 263,
    unicode: "l"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v517h77v-87q53 78 123 94 21 4 44 4 114 0 164-99l2-4q70 102 182 103 121 0 168-96 24-48 24-112V0h-77v302q0 118-83 148-23 8-51 8-76 0-116-62-27-42-27-98V0h-76v304q0 111-77 143-25 11-56 11-76 0-117-65-27-43-27-98V0H86z",
    glyphName: "m",
    horizAdvX: 948,
    unicode: "m"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v517h77v-90q64 100 177 101 117 0 169-90 29-50 29-117V0h-77v302q0 111-80 145-29 11-63 11-85 0-128-67-27-41-27-95V0H86z",
    glyphName: "n",
    horizAdvX: 616,
    unicode: "n"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M322-12q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45z",
    glyphName: "o",
    horizAdvX: 646,
    unicode: "o"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86-160v677h77V413q82 114 198 115 103 0 175-75 72-77 72-193v-2q0-135-93-213-68-56-154-56-124 1-198 110v-259H86zM347 58q93 0 145 72 37 53 37 127v2q0 110-76 166-47 34-106 34-82 0-138-65-49-57-49-134v-2q0-101 74-160 51-40 113-40z",
    glyphName: "p",
    horizAdvX: 664,
    unicode: "p"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M501-160v264Q420-10 303-11q-103 0-175 75-72 77-72 193v2q0 135 94 213 68 56 153 56 124-1 198-110v99h77v-677h-77zM317 58q82 0 139 65 48 57 48 135v2q0 101-75 159-51 40-112 40-93 0-145-72-37-53-37-127v-2q0-110 76-166 47-34 106-34z",
    glyphName: "q",
    horizAdvX: 664,
    unicode: "q"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v517h77V382q45 101 136 133 36 12 75 11v-83h-6q-107 0-164-84-41-61-41-153V0H86z",
    glyphName: "r",
    horizAdvX: 405,
    unicode: "r"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M257-10Q147-10 54 58q-6 4-11 8l39 55q86-66 179-66 75 0 99 47 8 17 8 35v2q0 46-76 75-21 7-53 16-94 28-127 54-43 36-44 92v2q0 83 74 124 45 24 102 24 100-1 186-57l-35-58q-78 50-153 50-69 0-92-44-8-15-8-31v-2q0-41 68-68 20-7 65-21 103-31 138-70 28-33 28-78v-2q0-90-81-132-45-23-103-23z",
    glyphName: "s",
    horizAdvX: 498,
    unicode: "s"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M259-9Q137-9 117 96q-4 19-4 41v312H41v68h72v156h77V517h164v-68H190V147q2-85 87-86 38 1 75 18V13Q312-9 259-9z",
    glyphName: "t",
    horizAdvX: 404,
    unicode: "t"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M276-11q-117 0-169 90-29 50-29 117v321h77V215q0-111 80-145 29-11 63-11 83 0 127 65 28 42 28 97v296h76V0h-76v90Q389-10 276-11z",
    glyphName: "u",
    horizAdvX: 616,
    unicode: "u"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M259-4L35 517h85L294 88l175 429h83L327-4h-68z",
    glyphName: "v",
    horizAdvX: 587,
    unicode: "v"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M223-4L42 517h82l136-415 139 417h64l140-417 136 415h80L637-4h-67L431 404 291-4h-68z",
    glyphName: "w",
    horizAdvX: 861,
    unicode: "w"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M135 517l152-202 154 202h86L331 264 535 0h-89L286 213 125 0H39l202 263L47 517h88z",
    glyphName: "x",
    horizAdvX: 574,
    unicode: "x"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M307 86l166 431h82L338-17q-47-115-119-138-24-8-53-8-57 0-110 26l26 61q37-19 81-19 51 0 82 49 12 20 24 48L34 517h85z",
    glyphName: "y",
    horizAdvX: 591,
    unicode: "y"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M56 0v49l343 403H68v65h436v-49L160 65h344V0H56z",
    glyphName: "z",
    horizAdvX: 556,
    unicode: "z"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M428-90l-12-51Q259-113 219-38q-20 38-20 99v35q1 31 1 41 0 95-68 114-22 6-50 6H56v60h26q93 0 112 68 6 22 6 52 0 8-1 39v37q0 96 55 141 51 41 162 61l12-51q-109-29-137-69-19-28-19-92v-37q1-27 1-38 0-97-79-132-12-5-25-9 80-25 98-89 6-23 6-52 0-11-1-38V71q0-72 26-102 32-35 130-59z",
    glyphName: "braceleft",
    horizAdvX: 483,
    unicode: "{"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M119-128v926h65v-926h-65z",
    glyphName: "bar",
    horizAdvX: 303,
    unicode: "|"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M67-141L54-90q111 28 139 70 18 29 18 91v37q-1 27-1 38 0 97 79 132 12 5 25 9-78 24-96 84-8 25-8 57 0 11 1 38v37q0 71-25 100-32 35-132 61l13 51q157-28 197-103 20-38 20-99v-37q-1-31-1-39 0-90 58-111 25-9 59-9h26v-60h-26q-92 0-111-66-6-23-6-54 0-9 1-41V61q0-96-55-141-51-41-162-61z",
    glyphName: "braceright",
    horizAdvX: 483,
    unicode: "}"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M306 246q-25 0-72 21-42 20-62 20-27 0-41-27-5-9-11-23l-47 13q23 88 69 102 12 4 26 4 25 0 72-21 42-20 62-20 27 0 41 27 5 9 11 23l46-13q-23-87-67-102-13-4-27-4z",
    glyphName: "asciitilde",
    horizAdvX: 473,
    unicode: "~"
  }), /*#__PURE__*/React.createElement("glyph", {
    glyphName: "uni00A0",
    horizAdvX: 25000
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M90 595v105h92V595H90zM91 0v57l23 445h43l24-445V0H91z",
    glyphName: "exclamdown",
    horizAdvX: 271,
    unicode: "\\xA1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M416 706l-18-91q72-19 132-83l-50-52q-51 51-98 67l-77-392q8-1 21-1 88 1 159 77l48-45Q445 85 322 85q-18 0-27 1L277-6h-65l21 106q-98 35-146 129-29 59-29 124v2q0 116 82 196 77 74 183 74h12l16 81h65zM136 357v-2q0-97 69-156 21-18 44-29l76 386h-4q-89 0-143-72-42-55-42-127z",
    glyphName: "cent",
    horizAdvX: 581,
    unicode: "\\xA2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M67 0v46l84 21v228H67v69h84v108q1 115 63 178 61 60 158 60 128 0 210-103 2-3 4-5l-61-48q-55 69-120 80-16 3-34 3-60-1-98-37-43-45-43-128V364h279v-69H230V70h355V0H67z",
    glyphName: "sterling",
    horizAdvX: 644,
    unicode: "\\xA3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M100 266v62h180L27 700h94l223-342 225 342h90L404 328h182v-62H381v-88h205v-62H381V0h-76v116H100v62h205v88H100z",
    glyphName: "yen",
    horizAdvX: 686,
    unicode: "\\xA5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M438 226q73-39 74-101v-2q0-78-79-113-45-20-105-20Q192-9 99 85l50 48q81-77 181-77 87 0 101 50 2 8 2 16v2q0 37-61 61-37 15-102 31-162 37-196 94-12 22-12 48v2q0 71 85 102 22 8 47 12-73 39-74 101v2q0 78 79 113 45 20 105 20 136-1 229-95l-50-48q-81 77-181 77-95 0-102-57-1-5-1-9v-2q0-37 62-62 37-15 101-30 151-37 189-83 19-25 19-59v-2q0-69-81-100-24-9-51-14zm-51 37q70 0 99 39 10 15 10 30v2q0 44-94 74-22 7-48 13-66 16-109 16-70 0-99-39-10-15-10-30v-2q0-44 94-74 22-7 48-13 64-16 109-16z",
    glyphName: "section",
    horizAdvX: 632,
    unicode: "\\xA7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M293 595v95h89v-95h-89zm-175 0v95h89v-95h-89z",
    glyphName: "dieresis",
    horizAdvX: 500,
    unicode: "\\xA8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M414-12Q266-12 161 90 60 190 53 332v18q0 143 98 247 99 106 244 114 11 1 21 1 148 0 253-102 101-100 108-242v-18q0-143-98-247Q580-3 435-11q-11-1-21-1zm0 31q140 0 236 99 93 97 94 232v2q0 136-93 232-96 97-235 97-140 0-236-99-93-97-94-232v-2q0-136 93-232 96-97 235-97zm5 144q-92 0-146 72-40 52-40 119v2q0 91 67 147 53 44 121 44 77 0 136-53 5-4 8-7l-37-40q-52 49-108 50-69 0-107-59-24-37-24-81v-2q0-73 55-115 35-26 77-26 55 0 106 46l4 4 36-35q-59-60-131-65-9-1-17-1z",
    glyphName: "copyright",
    horizAdvX: 830,
    unicode: "\\xA9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M168 408q-61 0-91 41-16 22-16 49v2q0 65 69 86 25 7 54 7 44 0 80-11v5q0 65-67 71h-11q-38 0-86-22l-15 42q59 25 106 25 58-1 93-32 29-30 29-84V414h-49v38q-38-44-96-44zm9 42q55 0 78 37 9 16 9 33v24q-32 11-76 11-60 0-73-38-2-8-2-15v-2q0-36 41-47 11-3 23-3zM58 289v47h260v-47H58z",
    glyphName: "ordfeminine",
    horizAdvX: 390,
    unicode: "\\xAA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M436 42L271 255v8l165 212 55-32-132-183L491 74zm-223 0L48 255v8l165 212 56-32-133-183L269 74z",
    glyphName: "guillemotleft",
    horizAdvX: 550,
    unicode: "\\xAB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M202 360q-85 0-137 66-37 48-37 108v1q0 82 64 135 48 40 110 40 85 0 137-66 37-48 37-108v-1q0-82-64-135-48-40-110-40zm0 19q77 0 123 62 31 43 31 94v1q0 76-59 123-42 32-95 32-77 0-123-62-31-43-31-94v-1q0-76 59-123 42-32 95-32zm-68 71v177h80q56 0 66-41 2-8 2-15v-1q0-39-38-52-2-1-3-1l47-67h-41l-42 61h-37v-61h-34zm34 89h43q34 3 36 29v1q0 24-27 28h-52v-58z",
    glyphName: "registered",
    horizAdvX: 403,
    unicode: "\\xAE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M94 615v63h312v-63H94z",
    glyphName: "macron",
    horizAdvX: 500,
    unicode: "\\xAF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M229 400q-72 0-121 58-36 43-36 94v2q0 72 61 119 44 33 96 33 72 0 120-57 37-43 37-95v-2q0-68-59-116-45-36-98-36zm0 52q55 0 84 47 15 25 15 53v2q0 52-43 83-26 17-56 17-55 0-84-47-15-25-15-53v-2q0-52 43-83 26-17 56-17z",
    glyphName: "degree",
    horizAdvX: 458,
    unicode: "\\xB0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M549 364H349V168h-73v196H77v70h199v196h73V434h200v-70zm0-364H77v69h472V0z",
    glyphName: "plusminus",
    horizAdvX: 625,
    unicode: "\\xB1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M59 424v44l144 126q64 54 74 88 3 12 3 24 0 45-42 62-15 6-32 6-55 0-100-62-3-3-4-5l-38 27q52 78 124 86 11 1 21 1 72 0 107-51 18-28 18-60 0-53-50-104-16-16-41-38l-113-96h207v-48H59z",
    glyphName: "two.sup",
    horizAdvX: 400,
    unicode: "\\xB2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M197 414q-86 1-146 70l35 35q49-57 112-58 52 0 73 39 8 16 8 33 0 54-65 68-17 3-36 3h-33l-10 33 126 126H73v48h254v-42L203 646q93-6 120-68 9-21 9-44 0-68-61-102-33-18-74-18z",
    glyphName: "three.sup",
    horizAdvX: 400,
    unicode: "\\xB3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M182 595l94 145 80-37-114-108h-60z",
    glyphName: "acute",
    horizAdvX: 500,
    unicode: "\\xB4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M645 64V-1q-23-6-54-6-102 1-122 90-59-90-155-93Q203-9 154 91h-1q9-62 9-127v-124H86v677h77V220q0-89 63-135 38-28 87-28 80 0 123 66 28 43 28 97v297h76V134q2-74 68-75 19 0 37 5z",
    glyphName: "mu",
    horizAdvX: 665,
    unicode: "\\xB5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M338 0v264h-11q-150 0-227 81-52 56-52 136v2q0 121 104 180 67 37 160 37h106V0h-80z",
    glyphName: "paragraph",
    horizAdvX: 510,
    unicode: "\\xB6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M76 248v105h92V248H76z",
    glyphName: "periodcentered",
    horizAdvX: 244,
    unicode: "\\xB7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M225-155l-75 34 92 134h61z",
    glyphName: "cedilla",
    horizAdvX: 500,
    unicode: "\\xB8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M211 424h-52v339l-86-33-13 45 110 43h41V424z",
    glyphName: "one.sup",
    horizAdvX: 325,
    unicode: "\\xB9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M194 407q-77 0-120 62-26 38-26 85v2q0 74 57 119 41 30 91 30 77 0 120-62 26-38 26-85v-2q0-74-57-119-41-30-91-30zM51 289v47h288v-47H51zm145 166q58 0 82 52 10 22 10 47v2q0 58-45 87-23 14-49 14-58 0-82-52-10-22-10-47v-2q0-59 45-87 22-14 49-14z",
    glyphName: "ordmasculine",
    horizAdvX: 390,
    unicode: "\\xBA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M337 42l-56 32 133 184-133 185 56 32 165-212v-8zm-222 0L59 74l132 184L59 443l56 32 164-212v-8z",
    glyphName: "guillemotright",
    horizAdvX: 550,
    unicode: "\\xBB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M209 313h-52v339l-86-33-13 45 110 42h41V313zM135 0l248 359 228 341h54L417 341 189 0h-54zm590 87V-2h-48v89H487l-11 45 193 261h56V130h54V87h-54zm-48 43v200L529 130h148z",
    glyphName: "onequarter",
    horizAdvX: 825,
    unicode: "\\xBC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M494 0v44l144 126q64 54 74 88 3 12 3 24 0 45-42 62-15 6-32 6-55 0-100-62-3-3-4-5l-38 27q52 78 124 86 11 1 21 1 72 0 107-51 18-28 18-60 0-53-50-104-16-16-41-38L565 48h207V0H494zM125 0l248 359 228 341h54L407 341 179 0h-54zm84 313h-52v339l-86-33-13 45 110 42h41V313z",
    glyphName: "onehalf",
    horizAdvX: 825,
    unicode: "\\xBD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M800 87V-2h-48v89H562l-11 45 193 261h56V130h54V87h-54zm-48 43v200L604 130h148zM205 0l248 359 228 341h54L487 341 259 0h-54zm-8 303q-86 1-146 70l35 35q49-57 112-58 52 0 73 39 8 16 8 33 0 54-65 68-17 3-36 3h-33l-10 33 126 126H73v48h254v-42L203 535q93-6 120-68 9-21 9-44 0-68-61-102-33-18-74-18z",
    glyphName: "threequarters",
    horizAdvX: 900,
    unicode: "\\xBE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M246 595v105h92V595h-92zM272-9Q148-9 86 72q-38 50-38 117v2q0 130 126 182 38 15 82 21l9 108h51l16-162-5-5q-154-4-190-92-9-23-9-49v-2q0-72 61-108 37-22 85-22 101 1 181 94l51-49Q404-5 272-9z",
    glyphName: "questiondown",
    horizAdvX: 537,
    unicode: "\\xBF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm193 516h-64l-115 93 78 36z",
    glyphName: "Agrave",
    unicode: "\\xC0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm129 516l100 129 79-36-115-93h-64z",
    glyphName: "Aacute",
    unicode: "\\xC1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm15 514l110 118h72l110-118h-72l-75 60-75-60h-70z",
    glyphName: "Acircumflex",
    unicode: "\\xC2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm234 516q-24 0-77 22-43 17-57 17-27 0-42-27-5-9-10-21l-49 14q26 89 76 100 9 2 18 2 24 0 77-22 45-17 57-17 27 0 42 27 5 8 10 20l49-14q-26-88-76-99-9-2-18-2z",
    glyphName: "Atilde",
    unicode: "\\xC3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l319 705h74L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm208 516v90h93v-90h-93zm-187 0v90h93v-90h-93z",
    glyphName: "Adieresis",
    unicode: "\\xC4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M39 0l300 664q-54 29-55 86 0 55 52 84 27 15 59 15 61 0 94-46 17-24 17-53-1-57-55-86L751 0h-85l-82 185H203L120 0H39zm195 256h319L394 613zm161 433q46 0 62 36 5 12 5 25 0 40-38 56-14 5-29 5-46 0-62-36-5-12-5-25 0-40 38-56 14-5 29-5z",
    glyphName: "Aring",
    unicode: "\\xC5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M17 0l411 700h552v-72H571V389h364v-72H571V72h414V0H491v185H209L100 0H17zm232 256h242v374h-24z",
    glyphName: "AE",
    horizAdvX: 1045,
    unicode: "\\xC6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M369-155l-75 34L371-9Q228 10 142 122q-74 98-74 226v2q0 148 97 252 107 107 257 110 143 0 244-85 15-12 29-26l-54-58q-89 84-185 94-17 2-35 2-122 0-201-91-70-82-70-196v-2q0-130 86-214 77-75 185-75 106 0 194 73 16 13 32 28l52-51Q588-5 440-11h-5z",
    glyphName: "Ccedilla",
    horizAdvX: 742,
    unicode: "\\xC7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M386 762h-64l-115 93 78 36zM99 0v700h506v-72H178V389h382v-72H178V72h432V0H99z",
    glyphName: "Egrave",
    horizAdvX: 670,
    unicode: "\\xC8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M321 762l100 129 79-36-115-93h-64zM99 0v700h506v-72H178V389h382v-72H178V72h432V0H99z",
    glyphName: "Eacute",
    horizAdvX: 670,
    unicode: "\\xC9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h506v-72H178V389h382v-72H178V72h432V0H99zm108 762l110 118h72l110-118h-72l-75 60-75-60h-70z",
    glyphName: "Ecircumflex",
    horizAdvX: 670,
    unicode: "\\xCA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M401 762v90h93v-90h-93zm-187 0v90h93v-90h-93zM99 0v700h506v-72H178V389h382v-72H178V72h432V0H99z",
    glyphName: "Edieresis",
    horizAdvX: 670,
    unicode: "\\xCB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 0v700h79V0h-79zm73 762h-64L0 855l78 36z",
    glyphName: "Igrave",
    horizAdvX: 291,
    unicode: "\\xCC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 0v700h79V0h-79zm9 762l100 129 79-36-115-93h-64z",
    glyphName: "Iacute",
    horizAdvX: 291,
    unicode: "\\xCD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 0v700h79V0h-79zM1 762l110 118h72l110-118h-72l-75 60-75-60H1z",
    glyphName: "Icircumflex",
    horizAdvX: 291,
    unicode: "\\xCE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M106 0v700h79V0h-79zm89 762v90h93v-90h-93zM8 762v90h93v-90H8z",
    glyphName: "Idieresis",
    horizAdvX: 291,
    unicode: "\\xCF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M54 320v64h75v316h243q170 0 276-107 96-98 96-241v-2q0-150-105-250Q533 0 372 0H129v320H54zm608 28v2q0 129-90 208-81 69-200 69H208V384h210v-64H208V73h164q148 0 229 98 61 74 61 177z",
    glyphName: "Eth",
    horizAdvX: 812,
    unicode: "\\xD0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M468 760q-24 0-77 22-43 17-57 17-27 0-42-27-5-9-10-21l-49 14q26 89 76 100 9 2 18 2 24 0 77-22 45-17 57-17 27 0 42 27 5 8 10 20l49-14q-26-88-76-99-9-2-18-2zM99 0v700h74l441-561v561h77V0h-63L176 574V0H99z",
    glyphName: "Ntilde",
    unicode: "\\xD1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M457 772h-64l-115 93 78 36zM424-12Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "Ograve",
    horizAdvX: 850,
    unicode: "\\xD2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M393 772l100 129 79-36-115-93h-64zm31-784Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "Oacute",
    horizAdvX: 850,
    unicode: "\\xD3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M424-12Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78zM279 772l110 118h72l110-118h-72l-75 60-75-60h-70z",
    glyphName: "Ocircumflex",
    horizAdvX: 850,
    unicode: "\\xD4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M498 772q-24 0-77 22-43 17-57 17-27 0-42-27-5-9-10-21l-49 14q26 89 76 100 9 2 18 2 24 0 77-22 45-17 57-17 27 0 42 27 5 8 10 20l49-14q-26-88-76-99-9-2-18-2zM424-12Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "Otilde",
    horizAdvX: 850,
    unicode: "\\xD5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M472 772v90h93v-90h-93zm-187 0v90h93v-90h-93zM424-12Q265-12 163 99 68 203 68 348v2q0 145 95 249 107 111 263 113 159 0 261-111 95-104 95-249v-2q0-145-95-249Q580-10 424-12zm2 73q126 0 205 93 69 82 69 194v2q0 127-85 211-79 78-191 78-126 0-205-93-69-82-69-194v-2q0-127 85-211 79-78 191-78z",
    glyphName: "Odieresis",
    horizAdvX: 850,
    unicode: "\\xD6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M486 127L312 304 138 127l-50 50 176 174L88 525l52 52 174-177 174 177 50-50-177-174 177-174z",
    glyphName: "multiply",
    horizAdvX: 625,
    unicode: "\\xD7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M707 705h83l-99-109q91-101 91-244v-2q0-145-95-249Q580-10 424-12q-127 1-220 73L143-5H60l98 108Q68 206 68 348v2q0 145 95 249 107 111 263 113 124-1 219-73zM149 352v-1q1-110 63-190l383 420q-77 60-171 60-126 0-206-94-69-82-69-195zM426 59q126 0 206 94 69 82 69 195v1q-1 108-64 189L254 119q73-60 172-60z",
    glyphName: "Oslash",
    horizAdvX: 850,
    unicode: "\\xD8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M411 760h-64l-115 93 78 36zM379-11q-163 0-240 113-51 77-51 191v407h79V298q0-165 114-217 44-19 100-19 142 0 190 114 21 50 21 117v407h79V299q0-195-131-271-68-39-161-39z",
    glyphName: "Ugrave",
    horizAdvX: 759,
    unicode: "\\xD9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M347 760l100 129 79-36-115-93h-64zm32-771q-163 0-240 113-51 77-51 191v407h79V298q0-165 114-217 44-19 100-19 142 0 190 114 21 50 21 117v407h79V299q0-195-131-271-68-39-161-39z",
    glyphName: "Uacute",
    horizAdvX: 759,
    unicode: "\\xDA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M379-11q-163 0-240 113-51 77-51 191v407h79V298q0-165 114-217 44-19 100-19 142 0 190 114 21 50 21 117v407h79V299q0-195-131-271-68-39-161-39zM233 760l110 118h72l110-118h-72l-75 60-75-60h-70z",
    glyphName: "Ucircumflex",
    horizAdvX: 759,
    unicode: "\\xDB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M427 760v90h93v-90h-93zm-187 0v90h93v-90h-93zM379-11q-163 0-240 113-51 77-51 191v407h79V298q0-165 114-217 44-19 100-19 142 0 190 114 21 50 21 117v407h79V299q0-195-131-271-68-39-161-39z",
    glyphName: "Udieresis",
    horizAdvX: 759,
    unicode: "\\xDC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M318 0v277L27 700h96l236-350 238 350h92L398 278V0h-80zm8 760l100 129 79-36-115-93h-64z",
    glyphName: "Yacute",
    horizAdvX: 716,
    unicode: "\\xDD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M99 0v700h79V580h183q149 0 219-90 43-55 43-132v-2q0-130-111-191-70-39-164-39H178V0H99zm79 198h173q114 0 165 70 27 37 27 85v2q0 105-100 139-39 13-88 13H178V198z",
    glyphName: "Thorn",
    horizAdvX: 668,
    unicode: "\\xDE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M292-2v62q153 4 184 91 7 19 7 41v2q0 95-131 127-28 7-60 10v57q143 62 148 162v2q0 71-61 102-31 15-70 15-84 0-123-71-23-41-23-96V0H86v501q0 131 89 195 58 41 138 41 113 0 171-75 35-46 35-105v-2q0-104-103-165-18-10-36-18 151-35 177-138 5-20 5-40v-2q0-112-105-163Q389-4 292-2z",
    glyphName: "germandbls",
    horizAdvX: 620,
    unicode: "\\xDF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zm6 545L147 703l80 37 94-145h-60z",
    glyphName: "agrave",
    horizAdvX: 579,
    unicode: "\\xE0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zm3 545l94 145 80-37-114-108h-60z",
    glyphName: "aacute",
    horizAdvX: 579,
    unicode: "\\xE1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zM149 595l106 131h68l106-131h-66l-75 67-75-67h-64z",
    glyphName: "acircumflex",
    horizAdvX: 579,
    unicode: "\\xE2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zm107 545q-25 0-72 21-49 19-62 19-27 0-41-26-5-9-11-23l-47 13q23 87 69 101 12 4 26 4 27 0 72-20 42-20 62-20 27 0 41 26 5 9 11 23l47-13q-23-87-69-101-12-4-26-4z",
    glyphName: "atilde",
    horizAdvX: 579,
    unicode: "\\xE3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zm77 545v95h89v-95h-89zm-175 0v95h89v-95h-89z",
    glyphName: "adieresis",
    horizAdvX: 579,
    unicode: "\\xE4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M240-11q-96 0-152 57-41 43-41 104v2q0 104 101 146 52 21 120 21 80 0 159-22v18q0 113-104 136-23 5-50 5-78 0-157-38l-23 63q92 43 188 43 110-1 167-57 53-54 53-151V0h-74v78q-69-88-187-89zm15 61q91 0 142 58 31 36 31 82v50q-79 22-152 22-113 0-143-67-8-19-8-40v-2q0-62 63-90 31-13 67-13zm34 543q-59 0-91 47-18 27-18 58 0 55 48 86 28 18 61 18 59 0 91-47 18-27 18-57 0-57-49-88-28-17-60-17zm0 36q40 0 60 35 9 16 9 34 0 40-36 60-16 9-33 9-40 0-60-36-9-16-9-33 0-42 37-61 16-8 32-8z",
    glyphName: "aring",
    horizAdvX: 579,
    unicode: "\\xE5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M242-11Q140-11 85 49 47 91 47 150v2q0 103 98 145 51 22 119 22 74 0 153-22v18q0 124-118 139-15 2-31 2-73 0-152-38l-23 63q92 43 183 43 150-1 190-111 53 89 151 110 23 5 47 5 127 0 194-102 47-73 47-171 0-9-2-25H494q10-106 91-152 42-23 90-23 92 1 163 73l48-43q-87-96-213-97-116 0-191 87-8 9-14 17Q366-10 242-11zm251 298h333q-9 103-76 150-39 26-88 26-87 0-136-78-27-43-33-98zM251 51q106 1 186 92-18 46-21 98-75 21-144 21-112 0-140-68-7-18-7-39v-2q0-63 63-90 29-12 63-12z",
    glyphName: "ae",
    horizAdvX: 953,
    unicode: "\\xE6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M268-155l-75 34L271-7Q164 11 101 103q-47 70-47 153v2q0 117 82 197 76 73 183 73 117 0 201-86 4-3 6-6l-51-54q-65 68-132 77-13 1-25 1-90 0-144-73-41-55-41-127v-2q0-97 69-156 52-45 121-45 87 1 158 77l49-46Q447-5 334-11z",
    glyphName: "ccedilla",
    horizAdvX: 571,
    unicode: "\\xE7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M312-12q-115 0-190 83-68 76-68 186v2q0 123 81 201 70 68 167 68 128 0 195-103 46-72 46-170 0-17-1-25H132q10-107 92-152 41-23 90-23 92 1 163 73l48-43Q446-5 332-11q-10-1-20-1zM132 287h333q-9 106-79 152-37 24-86 24-86 0-135-78-27-43-33-98zm140 308L158 703l80 37 94-145h-60z",
    glyphName: "egrave",
    horizAdvX: 592,
    unicode: "\\xE8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M270 595l94 145 80-37-114-108h-60zm42-607q-115 0-190 83-68 76-68 186v2q0 123 81 201 70 68 167 68 128 0 195-103 46-72 46-170 0-17-1-25H132q10-107 92-152 41-23 90-23 92 1 163 73l48-43Q446-5 332-11q-10-1-20-1zM132 287h333q-9 106-79 152-37 24-86 24-86 0-135-78-27-43-33-98z",
    glyphName: "eacute",
    horizAdvX: 592,
    unicode: "\\xE9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M161 595l106 131h68l106-131h-66l-75 67-75-67h-64zM312-12q-115 0-190 83-68 76-68 186v2q0 123 81 201 70 68 167 68 128 0 195-103 46-72 46-170 0-17-1-25H132q10-107 92-152 41-23 90-23 92 1 163 73l48-43Q446-5 332-11q-10-1-20-1zM132 287h333q-9 106-79 152-37 24-86 24-86 0-135-78-27-43-33-98z",
    glyphName: "ecircumflex",
    horizAdvX: 592,
    unicode: "\\xEA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M344 595v95h89v-95h-89zm-175 0v95h89v-95h-89zM312-12q-115 0-190 83-68 76-68 186v2q0 123 81 201 70 68 167 68 128 0 195-103 46-72 46-170 0-17-1-25H132q10-107 92-152 41-23 90-23 92 1 163 73l48-43Q446-5 332-11q-10-1-20-1zM132 287h333q-9 106-79 152-37 24-86 24-86 0-135-78-27-43-33-98z",
    glyphName: "edieresis",
    horizAdvX: 592,
    unicode: "\\xEB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M93 0v517h77V0H93zm11 595L-10 703l80 37 94-145h-60z",
    glyphName: "igrave",
    horizAdvX: 263,
    unicode: "\\xEC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M102 595l94 145 80-37-114-108h-60zM93 0v517h77V0H93z",
    glyphName: "iacute",
    horizAdvX: 263,
    unicode: "\\xED"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M-7 595L99 726h68l106-131h-66l-75 67-75-67H-7zM93 0v517h77V0H93z",
    glyphName: "icircumflex",
    horizAdvX: 263,
    unicode: "\\xEE"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M176 595v95h89v-95h-89zM1 595v95h89v-95H1zM93 0v517h77V0H93z",
    glyphName: "idieresis",
    horizAdvX: 263,
    unicode: "\\xEF"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M493 685l-86-36q183-179 184-365v-2q0-146-93-229-73-65-179-65-116 0-195 87-70 79-70 185v2q0 121 87 196 69 58 157 58 100-1 179-72-43 85-139 176l-115-47-23 47 95 39q-42 36-89 71h111l48-41 105 44zM324 57q97 0 151 76 37 54 37 123v2q0 96-71 152-53 41-125 41-98 0-150-77-33-51-33-116v-2q0-93 67-152 54-47 124-47z",
    glyphName: "eth",
    horizAdvX: 646,
    unicode: "\\xF0"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86 0v517h77v-90q64 100 177 101 117 0 169-90 29-50 29-117V0h-77v302q0 111-80 145-29 11-63 11-85 0-128-67-27-41-27-95V0H86zm298 595q-25 0-72 21-49 19-62 19-27 0-41-26-5-9-11-23l-47 13q23 87 69 101 12 4 26 4 27 0 72-20 42-20 62-20 27 0 41 26 5 9 11 23l47-13q-23-87-69-101-12-4-26-4z",
    glyphName: "ntilde",
    horizAdvX: 616,
    unicode: "\\xF1"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M322-12q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45zm-30 538L180 703l80 37 94-145h-60z",
    glyphName: "ograve",
    horizAdvX: 646,
    unicode: "\\xF2"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M292 595l94 145 80-37-114-108h-60zm30-607q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45z",
    glyphName: "oacute",
    horizAdvX: 646,
    unicode: "\\xF3"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M183 595l106 131h68l106-131h-66l-75 67-75-67h-64zM322-12q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45z",
    glyphName: "ocircumflex",
    horizAdvX: 646,
    unicode: "\\xF4"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M322-12q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45zm71 538q-25 0-72 21-49 19-62 19-27 0-41-26-5-9-11-23l-47 13q23 87 69 101 12 4 26 4 27 0 72-20 42-20 62-20 27 0 41 26 5 9 11 23l47-13q-23-87-69-101-12-4-26-4z",
    glyphName: "otilde",
    horizAdvX: 646,
    unicode: "\\xF5"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M366 595v95h89v-95h-89zm-175 0v95h89v-95h-89zM322-12q-122 0-200 88-68 77-68 180v2q0 117 83 197 77 73 187 73 123 0 202-89 67-76 67-179v-2q0-117-83-196-78-74-188-74zm2 69q95 0 151 76 39 54 39 123v2q0 95-68 155-54 47-124 47-96 0-150-76-39-55-39-124v-2q0-96 69-156 53-45 122-45z",
    glyphName: "odieresis",
    horizAdvX: 646,
    unicode: "\\xF6"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M262 499v103h101V499H262zm295-182H68v70h489v-70zM262 102v103h101V102H262z",
    glyphName: "divide",
    horizAdvX: 625,
    unicode: "\\xF7"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M530 523h78l-81-86q66-74 66-177v-2q0-117-83-196-78-74-188-74-92 1-162 53L116-5H39l79 85q-64 74-64 176v2q0 117 83 197 77 73 187 73 91-1 161-53zM324 55q97 0 153 78 38 54 38 123v1q-1 73-39 125L208 94q52-40 116-39zM131 260v-1q1-71 39-125l268 287q-52 40-116 40-96 0-152-76-39-55-39-125z",
    glyphName: "oslash",
    horizAdvX: 646,
    unicode: "\\xF8"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M276-11q-117 0-169 90-29 50-29 117v321h77V215q0-111 80-145 29-11 63-11 83 0 127 65 28 42 28 97v296h76V0h-76v90Q389-10 276-11zm-2 606L160 703l80 37 94-145h-60z",
    glyphName: "ugrave",
    horizAdvX: 616,
    unicode: "\\xF9"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M272 595l94 145 80-37-114-108h-60zm4-606q-117 0-169 90-29 50-29 117v321h77V215q0-111 80-145 29-11 63-11 83 0 127 65 28 42 28 97v296h76V0h-76v90Q389-10 276-11z",
    glyphName: "uacute",
    horizAdvX: 616,
    unicode: "\\xFA"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M163 595l106 131h68l106-131h-66l-75 67-75-67h-64zM276-11q-117 0-169 90-29 50-29 117v321h77V215q0-111 80-145 29-11 63-11 83 0 127 65 28 42 28 97v296h76V0h-76v90Q389-10 276-11z",
    glyphName: "ucircumflex",
    horizAdvX: 616,
    unicode: "\\xFB"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M346 595v95h89v-95h-89zm-175 0v95h89v-95h-89zM276-11q-117 0-169 90-29 50-29 117v321h77V215q0-111 80-145 29-11 63-11 83 0 127 65 28 42 28 97v296h76V0h-76v90Q389-10 276-11z",
    glyphName: "udieresis",
    horizAdvX: 616,
    unicode: "\\xFC"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M307 86l166 431h82L338-17q-47-115-119-138-24-8-53-8-57 0-110 26l26 61q37-19 81-19 51 0 82 49 12 20 24 48L34 517h85zm-40 509l94 145 80-37-114-108h-60z",
    glyphName: "yacute",
    horizAdvX: 591,
    unicode: "\\xFD"
  }), /*#__PURE__*/React.createElement("glyph", {
    d: "M86-160v890h77V413q82 114 198 115 103 0 175-75 72-77 72-193v-2q0-135-93-213-68-56-154-56-124 1-198 110v-259H86zM347 58q93 0 145 72 37 53 37 127v2q0 110-76 166-47 34-106 34-82 0-138-65-49-57-49-134v-2q0-101 74-160 51-40 113-40z",
    glyphName: "thorn",
    horizAdvX: 664,
    unicode: "\\xFE"
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "Eth,Dcroat,uni0492",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "J,uni0408",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "uni018F,uni04D8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "schwa,uni04D9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "F",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "V,uni0474",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "J,uni0408",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "V,uni0474",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Q.alt",
    g2: "x,uni0445,uni04B3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "J,uni0408",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "uni018F,uni04D8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotright,guilsinglright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "schwa,uni04D9",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "V,uni0474",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "x,uni0445,uni04B3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "t,tcommaaccent,tcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "V",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "V,uni0474",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "ampersand",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "J,uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "asterisk",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "backslash",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "J,uni0408",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni03A6,uni0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni03AD,uni03B5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "braceleft",
    g2: "uni03C9,uni03CE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "J,uni0408",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni03A6,uni0424",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni03AD,uni03B5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "bracketleft",
    g2: "uni03C9,uni03CE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fiveeighths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fivesixths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "fourfifths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "germandbls",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "nine",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "oneeighth",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "oneeighth.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onefifth",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onefifth.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onehalf",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onehalf.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onequarter",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onequarter.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onesixth",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onesixth.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onethird",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "onethird.alt",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "J,uni0408",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni018F,uni04D8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "schwa,uni04D9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni03A6,uni0424",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni03AD,uni03B5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni03C9,uni03CE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "parenleft",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "V,uni0474",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "t,tcommaaccent,tcaron",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "questiondown",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seven",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "seveneighths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "Eth,Dcroat,uni0492",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "J,uni0408",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "schwa,uni04D9",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "x,uni0445,uni04B3",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "t,tcommaaccent,tcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03A6,uni0424",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03AD,uni03B5",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03C9,uni03CE",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni043B,uni0459",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni044A,uni0463,uni04A1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 88
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "J,uni0408",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 58
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "x,uni0445,uni04B3",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "t,tcommaaccent,tcaron",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "slash.tab",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "threeeighths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "threefifths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "threequarters",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "twofifths",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "twothirds",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteright,quotedblright",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "hyphen,endash,emdash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03A6,uni0424",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0394",
    g2: "quoteleft,quotedblleft",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "guillemotright,guilsinglright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "hyphen,endash,emdash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "uni03A6,uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "uni03AD,uni03B5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "uni03C9,uni03CE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A3",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "hyphen,endash,emdash",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "guillemotleft,guilsinglleft",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "uni03A6,uni0424",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "uni03AD,uni03B5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A8",
    g2: "uni03C9,uni03CE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "hyphen,endash,emdash",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "guillemotleft,guilsinglleft",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "uni03AD,uni03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "uni03C9,uni03CE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B6",
    g2: "quoteleft,quotedblleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B8",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "quoteright,quotedblright",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "uni03C9,uni03CE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BB",
    g2: "quoteleft,quotedblleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "hyphen,endash,emdash",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "guillemotleft,guilsinglleft",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "uni03AD,uni03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "uni03C9,uni03CE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03BE",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C0",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C0",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C0",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C0",
    g2: "hyphen,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C0",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C2",
    g2: "guillemotright,guilsinglright",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C2",
    g2: "hyphen,endash,emdash",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C2",
    g2: "guillemotleft,guilsinglleft",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "guillemotright,guilsinglright",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C3",
    g2: "uni03C9,uni03CE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "hyphen,endash,emdash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "guillemotleft,guilsinglleft",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C4",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "hyphen,endash,emdash",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "guillemotleft,guilsinglleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "uni03AD,uni03B5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "uni03C9,uni03CE",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C7",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "V,uni0474",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni03A6,uni0424",
    k: -2
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni044A,uni0463,uni04A1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "quoteleft,quotedblleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0402",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteright,quotedblright",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "V,uni0474",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni03A6,uni0424",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni044A,uni0463,uni04A1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "quoteleft,quotedblleft",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040B",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "Eth,Dcroat,uni0492",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "V,uni0474",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni03A6,uni0424",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni043B,uni0459",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni044A,uni0463,uni04A1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0411",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "J,uni0408",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni018F,uni04D8",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "quoteright,quotedblright",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "schwa,uni04D9",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "V,uni0474",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "guillemotleft,guilsinglleft",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni03A6,uni0424",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni044A,uni0463,uni04A1",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "quoteleft,quotedblleft",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0414",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "Eth,Dcroat,uni0492",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "J,uni0408",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "V,uni0474",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "x,uni0445,uni04B3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni043B,uni0459",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni044A,uni0463,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni042D",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433.bgr",
    g2: "x,uni0445,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433.bgr",
    g2: "guillemotleft,guilsinglleft",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433.bgr",
    g2: "uni043B,uni0459",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433.bgr",
    g2: "uni044A,uni0463,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433.bgr",
    g2: "quoteleft,quotedblleft",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "quoteright,quotedblright",
    k: 99
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "schwa,uni04D9",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "hyphen,endash,emdash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "guillemotleft,guilsinglleft",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "uni043B,uni0459",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "uni044A,uni0463,uni04A1",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0434",
    g2: "quoteleft,quotedblleft",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "quoteright,quotedblright",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "schwa,uni04D9",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "x,uni0445,uni04B3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "hyphen,endash,emdash",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "guillemotleft,guilsinglleft",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "uni043B,uni0459",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "uni044A,uni0463,uni04A1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni043B",
    g2: "quoteleft,quotedblleft",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotright,guilsinglright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "schwa,uni04D9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "x,uni0445,uni04B3",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "guillemotleft,guilsinglleft",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni043B,uni0459",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0442",
    g2: "quoteleft,quotedblleft",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 124
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "J,uni0408",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni018F,uni04D8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "guillemotright,guilsinglright",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "schwa,uni04D9",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "x,uni0445,uni04B3",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "hyphen,endash,emdash",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni03A6,uni0424",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni043B,uni0459",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni044A,uni0463,uni04A1",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0474",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "schwa,uni04D9",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "hyphen,endash,emdash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "guillemotleft,guilsinglleft",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "uni043B,uni0459",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0475",
    g2: "quoteleft,quotedblleft",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "J,uni0408",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni018F,uni04D8",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotright,guilsinglright",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "schwa,uni04D9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "V,uni0474",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "x,uni0445,uni04B3",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "guillemotleft,guilsinglleft",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni03A6,uni0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni043B,uni0459",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni044A,uni0463,uni04A1",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B0",
    g2: "uni0452,uni045B",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni018F,uni04D8",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "V,uni0474",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "hyphen,endash,emdash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni03A6,uni0424",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni043B,uni0459",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni044A,uni0463,uni04A1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B2",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "guillemotright,guilsinglright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "schwa,uni04D9",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "hyphen,endash,emdash",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "guillemotleft,guilsinglleft",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "uni043B,uni0459",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04B3",
    g2: "uni044A,uni0463,uni04A1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni018F,uni04D8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "quoteright,quotedblright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 77
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "V,uni0474",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni03A6,uni0424",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni044A,uni0463,uni04A1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "quoteleft,quotedblleft",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni04BA",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni018F,uni04D8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "quoteright,quotedblright",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "schwa,uni04D9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "V,uni0474",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "hyphen,endash,emdash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "t,tcommaaccent,tcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03A6,uni0424",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03C9,uni03CE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni044A,uni0463,uni04A1",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "quoteleft,quotedblleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "asterisk",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "question",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0394",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03A3",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03A8",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03A9",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03B6",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03B8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03BB",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03BE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03C0",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03C4",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni03C7",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0414",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0431",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0432.bgr",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni0442",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "uni04B0",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0386,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    g2: "registered,servicemark,trademark",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "Eth,Dcroat,uni0492",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "question",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0394",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni03A3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni03A8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni03BB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni03C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni03C7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0414",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni0442",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "uni04B0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "B,uni0392,uni0412,uni0417,uni0498,uni04DE",
    g2: "ampersand",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "Eth,Dcroat,uni0492",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "J,uni0408",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni018F,uni04D8",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "schwa,uni04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "V,uni0474",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "hyphen,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni03A6,uni0424",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni044A,uni0463,uni04A1",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0414",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0442",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni04B0",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni042F",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0433.bgr",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni0434",
    k: -13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "C,Ccedilla,Cacute,Cdotaccent,Ccaron,uni0404,uni0421,uni04AA",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "J,uni0408",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "V,uni0474",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "braceright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "parenright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "D,Eth,Thorn,Dcaron,Dcroat",
    g2: "slash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "Eth,Dcroat,uni0492",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "schwa,uni04D9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni044A,uni0463,uni04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03B6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03BE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03C4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni03C7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni0431",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "E,AE,Egrave,Eacute,Ecircumflex,Edieresis,Emacron,Ebreve,Edotaccent,Eogonek,Ecaron,OE,AEacute,uni0388,uni0395,uni039E,uni0400,uni0401,uni0415,uni04D4,uni04D6,uni039E.alt,uni0388.calt",
    g2: "uni0434",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "Eth,Dcroat,uni0492",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "J,uni0408",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "V,uni0474",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "x,uni0445,uni04B3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni043B,uni0459",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "question",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0394",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03A3",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03B6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03BE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni03C7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0414",
    k: 53
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0442",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni04B0",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0433.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "uni0434",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "braceright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "bracketright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "parenright",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03A6,uni0424",
    g2: "slash",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "V,uni0474",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "G,Gbreve,Gdotaccent,Gcommaaccent",
    g2: "question",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "Eth,Dcroat,uni0492",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "J,uni0408",
    k: 208
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni018F,uni04D8",
    k: 49
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "guillemotright,guilsinglright",
    k: 109
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 134
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 158
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 149
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "schwa,uni04D9",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 122
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "V,uni0474",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "x,uni0445,uni04B3",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "hyphen,endash,emdash",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "guillemotleft,guilsinglleft",
    k: 136
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 112
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03A6,uni0424",
    k: 63
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03AD,uni03B5",
    k: 141
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03C9,uni03CE",
    k: 144
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 128
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni043B,uni0459",
    k: 197
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni044A,uni0463,uni04A1",
    k: 116
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 119
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0394",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03A3",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03A9",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03B6",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03B8",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03BB",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03BE",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03C0",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03C4",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03C7",
    k: 118
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0414",
    k: 163
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0431",
    k: 72
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0432.bgr",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0442",
    k: 84
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni04B0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni042F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0433.bgr",
    k: 148
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0434",
    k: 203
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni044F",
    k: 159
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "slash",
    k: 182
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03B2",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni03C1",
    k: 146
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0393,uni0403,uni0413,uni0490,uni0492,uni04A4",
    g2: "uni0493",
    k: 114
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "J,uni0408",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "uni043B,uni0459",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "uni0414",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "J,uni0408",
    g2: "uni0434",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni018F,uni04D8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "schwa,uni04D9",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "V,uni0474",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "hyphen,endash,emdash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "t,tcommaaccent,tcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03A6,uni0424",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03AD,uni03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03C9,uni03CE",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni044A,uni0463,uni04A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0394",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03A3",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03A8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03A9",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03B8",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03BE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03C0",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03C4",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03C7",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0431",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0432.bgr",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0442",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni04B0",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "ampersand",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni042F",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni0433.bgr",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni044F",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "K,Kcommaaccent,uni039A,uni040C,uni0416,uni041A,uni04A0,uni04C1,uni04DC",
    g2: "uni03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "Eth,Dcroat,uni0492",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni018F,uni04D8",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "schwa,uni04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "hyphen,endash,emdash",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni03A6,uni0424",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni043B,uni0459",
    k: -14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni044A,uni0463,uni04A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0452,uni045B",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "question",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0414",
    k: -45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0431",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0442",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni04B0",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0433.bgr",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0434",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "slash",
    k: -60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0496,uni049A",
    g2: "uni0493",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "Eth,Dcroat,uni0492",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "uni018F,uni04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteright,quotedblright",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "schwa,uni04D9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 93
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "V,uni0474",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "hyphen,endash,emdash",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "t,tcommaaccent,tcaron",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "quoteleft,quotedblleft",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "asterisk",
    k: 76
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "question",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "ampersand",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "L,Lacute,Lcommaaccent,Lcaron,Lslash",
    g2: "registered,servicemark,trademark",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "hyphen,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "guillemotleft,guilsinglleft",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni0394",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03A8",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03A9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03C7",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "parenright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni038F,uni03A9,uni038F.calt",
    g2: "uni03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "Eth,Dcroat,uni0492",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "J,uni0408",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni018F,uni04D8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "quoteright,quotedblright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "schwa,uni04D9",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "V,uni0474",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "t,tcommaaccent,tcaron",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: -4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03AD,uni03B5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03C9,uni03CE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni043B,uni0459",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni044A,uni0463,uni04A1",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0394",
    k: 67
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03A3",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03A9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03B6",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03BB",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03BE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03C0",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03C4",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03C7",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0414",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0442",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni04B0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "ampersand",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0433.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0434",
    k: 71
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "slash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03B2",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni03C1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "P,uni03A1,uni0420",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "Eth,Dcroat,uni0492",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "J,uni0408",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "V,uni0474",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "x,uni0445,uni04B3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni043B,uni0459",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni044A,uni0463,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "question",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0394",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03A3",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03A8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03B6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03BB",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03BE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni03C7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0414",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0442",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni04B0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0433.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "uni0434",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "braceright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "parenright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "O,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,uni018F,Oslashacute,uni038C,uni0398,uni039F,uni041E,uni042E,uni0472,uni04D8,uni04E6,uni04E8,uni0424.bgr,uni038C.calt",
    g2: "slash",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "V,uni0474",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "x,uni0445,uni04B3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "t,tcommaaccent,tcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni043B,uni0459",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni044A,uni0463,uni04A1",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "question",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni0442",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni04B0",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    g2: "uni042F",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "Eth,Dcroat,uni0492",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "quoteright,quotedblright",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 81
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "V,uni0474",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "x,uni0445,uni04B3",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "hyphen,endash,emdash",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni043B,uni0459",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni044A,uni0463,uni04A1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "quoteleft,quotedblleft",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "question",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni0442",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "uni04B0",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0409,uni040A,uni042A,uni042C,uni0462",
    g2: "parenright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "Eth,Dcroat,uni0492",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "J,uni0408",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni018F,uni04D8",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "guillemotright,guilsinglright",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 123
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "schwa,uni04D9",
    k: 111
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "x,uni0445,uni04B3",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "hyphen,endash,emdash",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "guillemotleft,guilsinglleft",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "t,tcommaaccent,tcaron",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03A6,uni0424",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03AD,uni03B5",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03C9,uni03CE",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 73
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni043B,uni0459",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni044A,uni0463,uni04A1",
    k: 74
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 87
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0394",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03A9",
    k: 44
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03B6",
    k: 48
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03B8",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03BB",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03BE",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03C0",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03C4",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03C7",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0414",
    k: 102
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0431",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0432.bgr",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0442",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "ampersand",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni042F",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0433.bgr",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0434",
    k: 113
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni044F",
    k: 104
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "slash",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03B2",
    k: 38
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni03C1",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "T,Tcommaaccent,Tcaron,uni03A4,uni0422",
    g2: "uni0493",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "Eth,Dcroat,uni0492",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "J,uni0408",
    k: -10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "schwa,uni04D9",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "V,uni0474",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "guillemotleft,guilsinglleft",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni03A6,uni0424",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni044A,uni0463,uni04A1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0414",
    k: -33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0431",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni04B0",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "uni0434",
    k: -23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0426,uni0429,uni04A2,uni04B6",
    g2: "slash",
    k: -43
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "J,uni0408",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "x,uni0445,uni04B3",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    g2: "slash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 140
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "Eth,Dcroat,uni0492",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "J,uni0408",
    k: 170
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni018F,uni04D8",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "guillemotright,guilsinglright",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 138
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 89
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 94
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "schwa,uni04D9",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 47
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "V,uni0474",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "x,uni0445,uni04B3",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "hyphen,endash,emdash",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "guillemotleft,guilsinglleft",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni03A6,uni0424",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 52
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni043B,uni0459",
    k: 126
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni044A,uni0463,uni04A1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0452,uni045B",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0414",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0431",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0432.bgr",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0442",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni04B0",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0433.bgr",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0434",
    k: 143
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni044F",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "slash",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    g2: "uni0493",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Eth,Dcroat,uni0492",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "J,uni0408",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "uni018F,uni04D8",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "schwa,uni04D9",
    k: 51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "V,uni0474",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "x,uni0445,uni04B3",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "hyphen,endash,emdash",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "t,tcommaaccent,tcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "ampersand",
    k: 41
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    g2: "slash",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "J,uni0408",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni018F,uni04D8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "guillemotright,guilsinglright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "schwa,uni04D9",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "hyphen,endash,emdash",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "guillemotleft,guilsinglleft",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "t,tcommaaccent,tcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03A6,uni0424",
    k: 54
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03AD,uni03B5",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03C9,uni03CE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni043B,uni0459",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni044A,uni0463,uni04A1",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0394",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03A3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03A8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03A9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03B6",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03B8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03BE",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03C0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03C4",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03C7",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0414",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0431",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0432.bgr",
    k: 28
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0442",
    k: 65
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni04B0",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "ampersand",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni0433.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "X,uni03A7,uni0425,uni049C",
    g2: "uni03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "Eth,Dcroat,uni0492",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "J,uni0408",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni018F,uni04D8",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "guillemotright,guilsinglright",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 105
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "schwa,uni04D9",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "x,uni0445,uni04B3",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "colon,semicolon,colon.tab,semicolon.tab",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "hyphen,endash,emdash",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "guillemotleft,guilsinglleft",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "b,h,k,l,thorn,kcommaaccent,lacute,lcommaaccent,lcaron,ldot,uni04BB,uni04CF,uni043A.bgr,uni044E.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "m,n,p,r,ntilde,dotlessi,nacute,ncommaaccent,ncaron,racute,rcommaaccent,rcaron,uni03AE,uni03B7,uni03BA,uni03BC,uni0432,uni0433,uni0438,uni0439,uni043A,uni043C,uni043D,uni043F,uni0440,uni0446,uni0448,uni0449,uni044B,uni044C,uni044E,uni0453,uni045A,uni045C,uni045D,uni045F,uni0491,uni049B,uni049D,uni04A3,uni04A5,uni04E3,uni04E5,uni04F9,uni043F.bgr,uni0442.bgr",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "i,j,igrave,iacute,icircumflex,idieresis,imacron,ibreve,iogonek,uni0456,uni0457,uni0458,i.dot",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "t,tcommaaccent,tcaron",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03A6,uni0424",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03AD,uni03B5",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03C9,uni03CE",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni043B,uni0459",
    k: 135
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni044A,uni0463,uni04A1",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0452,uni045B",
    k: -25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0394",
    k: 106
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03A3",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03A9",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03B6",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03B8",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03BB",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03BE",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03C0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03C4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03C7",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0414",
    k: 133
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0431",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0442",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni04B0",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "ampersand",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni042F",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0433.bgr",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0434",
    k: 145
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni044F",
    k: 82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "slash",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03B2",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni03C1",
    k: 110
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Y,Yacute,Ycircumflex,Ydieresis,uni038E,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    g2: "uni0493",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "Eth,Dcroat,uni0492",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni018F,uni04D8",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "schwa,uni04D9",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03A6,uni0424",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03AD,uni03B5",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03C9,uni03CE",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03A8",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03A9",
    k: 39
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03B6",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03B8",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03BE",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03C0",
    k: 19
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03C4",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03C7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "ampersand",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    g2: "uni03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "slash",
    k: 175
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "fiveeighths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "fivesixths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "fourfifths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "oneeighth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "oneeighth.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onefifth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onefifth.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onehalf",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onehalf.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onequarter",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onequarter.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onesixth",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onesixth.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onethird",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "onethird.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "seveneighths",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "threeeighths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "threefifths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "threequarters",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "twofifths",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "twothirds",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    g2: "zero.num,one.num,one.num_alt,two.num,three.num,four.num,five.num,six.num,seven.num,eight.num,nine.num",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon,colon.tab,semicolon.tab",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon,colon.tab,semicolon.tab",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon,colon.tab,semicolon.tab",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon,colon.tab,semicolon.tab",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "colon,semicolon,colon.tab,semicolon.tab",
    g2: "uni04B0",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "V,uni0474",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "x,uni0445,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni043B,uni0459",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni044A,uni0463,uni04A1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0417,uni042D,uni0498,uni04DE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0394",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03A3",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03A8",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03A9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03BB",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03C4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni03C7",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0414",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0442",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni04B0",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni0434",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "uni044F",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "one",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "seven",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "three",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "hyphen,endash,emdash",
    g2: "three.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 66
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "V,uni0474",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "x,uni0445,uni04B3",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni044A,uni0463,uni04A1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni03B6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni03BB",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni03C4",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotleft,guilsinglleft",
    g2: "uni04B0",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Z,Zacute,Zdotaccent,Zcaron,uni0396",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 86
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "V,uni0474",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "S,Sacute,Scedilla,Scaron,Scommaaccent,uni0405",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "X,uni03A7,uni0425,uni04B2",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "x,uni0445,uni04B3",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "t,tcommaaccent,tcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03C9,uni03CE",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni043B,uni0459",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044A,uni0463,uni04A1",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0416,uni0496,uni04C1,uni04DC",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0394",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03A3",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03A8",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03A9",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03B6",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03BE",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03C4",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni03C7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0414",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0442",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni04B0",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0433.bgr",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni0434",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "guillemotright,guilsinglright",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "C,G,Ccedilla,Cacute,Cdotaccent,Ccaron,Gbreve,Gdotaccent,Gcommaaccent,OE,uni0404,uni0421,uni04AA",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "O,Q,Ograve,Oacute,Ocircumflex,Otilde,Odieresis,Oslash,Omacron,Obreve,Ohungarumlaut,Oslashacute,uni0398,uni039F,uni041E,uni0472,uni04E6,uni04E8,Q.alt,uni0424.bgr,uni038C.calt",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni018F,uni04D8",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "quoteright,quotedblright",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "schwa,uni04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 96
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "V,uni0474",
    k: 120
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 130
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "f,f_f,fi,fl,f_f_i,f_f_l",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "t,tcommaaccent,tcaron",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03A6,uni0424",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03C9,uni03CE",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "U,Ugrave,Uacute,Ucircumflex,Udieresis,Umacron,Ubreve,Uring,Uhungarumlaut,Uogonek",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni044A,uni0463,uni04A1",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0427,uni04B6,uni04B8,uni04F4",
    k: 115
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni040E,uni0423,uni04EE,uni04F0,uni04F2",
    k: 69
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0394",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03A8",
    k: 68
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03B8",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03C0",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03C4",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni03C7",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0414",
    k: -24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0431",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0442",
    k: 95
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni04B0",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "uni0434",
    k: -21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "one",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "seven",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "comma,period,quotesinglbase,quotedblbase,ellipsis,period.tab,comma.tab,twodotleader.tab",
    g2: "zero",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "Eth,Dcroat,uni0492",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "J,uni0408",
    k: 100
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 37
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 42
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni03AD,uni03B5",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni03C9,uni03CE",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni043B,uni0459",
    k: 83
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0394",
    k: 92
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni03B6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni03BB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0414",
    k: 107
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0433.bgr",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni0434",
    k: 103
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteright,quotedblright",
    g2: "uni03C1",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "A,Agrave,Aacute,Acircumflex,Atilde,Adieresis,Aring,Amacron,Abreve,Aogonek,Aringacute,uni0391,uni039B,uni0410,uni041B,uni04D0,uni04D2,uni0386.calt",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "AE,AEacute,uni0409,uni04D4",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "Eth,Dcroat,uni0492",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "J,uni0408",
    k: 80
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni03AD,uni03B5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni03C9,uni03CE",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni043B,uni0459",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0394",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni03B6",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni03BB",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0414",
    k: 97
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0433.bgr",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni0434",
    k: 98
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "uni03C1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "quoteleft,quotedblleft",
    g2: "questiondown",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "t,tcommaaccent,tcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "uni044A,uni0463,uni04A1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "question",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "uni0432.bgr",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,amacron,abreve,aogonek,aringacute,uni0430,uni04D1,uni04D3,aring.alt2,aringacute.alt2",
    g2: "uni0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "quoteright,quotedblright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "guillemotleft,guilsinglleft",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "question",
    k: 33
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03B6",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03BB",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03BE",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03C0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03C4",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "uni03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0390,uni03AC,uni03AF,uni03B1,uni03B9,uni03BC,uni03CA",
    g2: "slash",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni044A,uni0463,uni04A1",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "question",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni03BB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni03C4",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "h,m,n,ntilde,hbar,nacute,ncommaaccent,ncaron,uni03AE,uni03B7,uni0452,uni045B,uni04BB,uni043F.bgr,uni0442.bgr",
    g2: "uni0442",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "guillemotright,guilsinglright",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "x,uni0445,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni043B,uni0459",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni044A,uni0463,uni04A1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "asterisk",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "question",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni0442",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "braceright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "b,p,thorn,uni0440",
    g2: "parenright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "quoteright,quotedblright",
    k: -15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "schwa,uni04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "hyphen,endash,emdash",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03C9,uni03CE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni043B,uni0459",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni044A,uni0463,uni04A1",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: -1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03B6",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03BB",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03BE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03C7",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0431",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0442",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "parenright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni03C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "c,ccedilla,cacute,cdotaccent,ccaron,uni03AD,uni03B5,uni0441,uni0454,uni04AB",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "x,uni0445,uni04B3",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni043B,uni0459",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni044A,uni0463,uni04A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "question",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni0442",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni0434",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "e,ae,egrave,eacute,ecircumflex,edieresis,emacron,ebreve,edotaccent,eogonek,ecaron,oe,aeacute,uni0435,uni0450,uni0451,uni04D5,uni04D7",
    g2: "parenright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteright,quotedblright",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "schwa,uni04D9",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "quoteleft,quotedblleft",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "asterisk",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "question",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "braceright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "bracketright",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "parenright",
    k: -30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "slash",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "f,f_f",
    g2: "registered,servicemark,trademark",
    k: -51
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "guillemotright,guilsinglright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 129
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 36
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "schwa,uni04D9",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "x,uni0445,uni04B3",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "hyphen,endash,emdash",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "guillemotleft,guilsinglleft",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni043B,uni0459",
    k: 91
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "quoteleft,quotedblleft",
    k: -5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni0433.bgr",
    k: 31
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni0434",
    k: 117
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni044F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "slash",
    k: 131
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0433,uni0453,uni0491,uni0493,uni04A5",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "schwa,uni04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "hyphen,endash,emdash",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "t,tcommaaccent,tcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03AD,uni03B5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03C9,uni03CE",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni044A,uni0463,uni04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03B6",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03B8",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03BB",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03BE",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03C4",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03C7",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0431",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0442",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0433.bgr",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "slash",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni03C1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "k,kcommaaccent,uni03BA,uni0436,uni043A,uni045C,uni04A1,uni04C2,uni04DD,uni0436.bgr,uni043A.bgr",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "guillemotright,guilsinglright",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "schwa,uni04D9",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "hyphen,endash,emdash",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "guillemotleft,guilsinglleft",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni043B,uni0459",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni044A,uni0463,uni04A1",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni0442",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni0434",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "slash",
    k: -82
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0497,uni049B",
    g2: "uni0493",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "guillemotleft,guilsinglleft",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "quoteleft,quotedblleft",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "question",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "uni03BB",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "uni03C4",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "uni03C7",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "braceright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "bracketright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "parenright",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03C9,uni03CE",
    g2: "slash",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 90
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "quoteright,quotedblright",
    k: -35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 21
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 22
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "schwa,uni04D9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "quoteleft,quotedblleft",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "asterisk",
    k: -17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "r,racute,rcommaaccent,rcaron",
    g2: "slash",
    k: 75
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "x,uni0445,uni04B3",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni043B,uni0459",
    k: 26
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni044A,uni0463,uni04A1",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "quoteleft,quotedblleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "asterisk",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "question",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni03BB",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni03C0",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni03C4",
    k: 29
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni03C7",
    k: 40
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni0442",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni0434",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "braceright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "o,ograve,oacute,ocircumflex,otilde,odieresis,oslash,omacron,obreve,ohungarumlaut,oslashacute,schwa,uni03B4,uni03BF,uni03C1,uni03C6,uni03CC,uni0431,uni043E,uni0444,uni044D,uni044E,uni0473,uni04D9,uni04E7,uni04E9,uni044E.bgr,uni0431.srb",
    g2: "parenright",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "x,uni0445,uni04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "t,tcommaaccent,tcaron",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni043B,uni0459",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni044A,uni0463,uni04A1",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 12
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "quoteleft,quotedblleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "question",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "bracketright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    g2: "parenright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "quoteright,quotedblright",
    k: 62
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 46
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "x,uni0445,uni04B3",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni043B,uni0459",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni044A,uni0463,uni04A1",
    k: 61
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "quoteleft,quotedblleft",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "question",
    k: 50
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni0442",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni0434",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "uni044F",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "braceright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "bracketright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni044A,uni044C,uni0459,uni045A,uni0463",
    g2: "parenright",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: -7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "schwa,uni04D9",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "guillemotleft,guilsinglleft",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "question",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "uni0431",
    k: 3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "uni0434",
    k: -20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0446,uni0449,uni04A3,uni04B7,uni0446.bgr,uni0449.bgr",
    g2: "slash",
    k: -55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    g2: "uni03BB",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    g2: "uni03C7",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    g2: "slash",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B0,uni03C5,uni03C8,uni03CB,uni03CD",
    g2: "uni03C1",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "schwa,uni04D9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "hyphen,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03AD,uni03B5",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03C9,uni03CE",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni043B,uni0459",
    k: 56
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni044A,uni0463,uni04A1",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "question",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03B6",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03B8",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03BB",
    k: 57
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03BE",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03C4",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03C7",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0442",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0433.bgr",
    k: 18
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0434",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni044F",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni03C1",
    k: 34
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "v,uni03B3,uni03BD,uni04AF,uni04B1",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "x,uni0445,uni04B3",
    k: 13
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "guillemotleft,guilsinglleft",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni043B,uni0459",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni044A,uni0463,uni04A1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "question",
    k: 8
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni0442",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni0434",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni0432,uni0437,uni0499,uni04DF",
    g2: "uni044F",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni043B,uni0459",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni044A,uni0463,uni04A1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "question",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni03BB",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni03C4",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni03C7",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni0442",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni0434",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "uni03B2,uni0432.bgr",
    g2: "parenright",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotright,guilsinglright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "schwa,uni04D9",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "hyphen,endash,emdash",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "guillemotleft,guilsinglleft",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "question",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "w,wcircumflex,wgrave,wacute,wdieresis",
    g2: "slash",
    k: 60
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 35
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "schwa,uni04D9",
    k: 32
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "hyphen,endash,emdash",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "guillemotleft,guilsinglleft",
    k: 45
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "u,ugrave,uacute,ucircumflex,udieresis,umacron,ubreve,uring,uhungarumlaut,uogonek,uni0390,uni03AF,uni03B9,uni03CA,uni0438.bgr,uni0439.bgr,uni0446.bgr,uni0448.bgr,uni0449.bgr",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni043B,uni0459",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni044A,uni0463,uni04A1",
    k: 23
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "question",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0431",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0432.bgr",
    k: 1
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0442",
    k: 16
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0433.bgr",
    k: 24
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0434",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni044F",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "bracketright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "x,uni0445,uni049D",
    g2: "uni0493",
    k: 11
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "guillemotright,guilsinglright",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "comma,period,ellipsis,period.tab,comma.tab,twodotleader.tab",
    k: 85
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "a,agrave,aacute,acircumflex,atilde,adieresis,aring,ae,amacron,abreve,aogonek,aringacute,aeacute,uni0430,uni04D1,uni04D3,uni04D5,aring.alt2,aringacute.alt2",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "s,sacute,scedilla,scaron,scommaaccent,uni0455",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "schwa,uni04D9",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "v,uni03B3,uni03BD,uni0475,uni04AF,uni04B1",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "w,wcircumflex,wgrave,wacute,wdieresis",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "z,zacute,zdotaccent,zcaron",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "x,uni0445,uni04B3",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "hyphen,endash,emdash",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "guillemotleft,guilsinglleft",
    k: 30
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0437,uni044D,uni0499,uni04DF",
    k: 6
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0447,uni04B7,uni04B9,uni04F5",
    k: 9
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni043B,uni0459",
    k: 59
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni044A,uni0463,uni04A1",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0436,uni0497,uni04C2,uni04DD,uni0436.bgr",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "question",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0431",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0442",
    k: 14
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0433.bgr",
    k: 27
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0434",
    k: 55
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni044F",
    k: 17
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "braceright",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "bracketright",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "slash",
    k: 70
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "y,yacute,ydieresis,ycircumflex,uni0443,uni045E,uni04EF,uni04F1,uni04F3,ygrave",
    g2: "uni0493",
    k: 7
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "J,uni0408",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 5
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "T,Tcommaaccent,Tcaron,uni03A4,uni0402,uni040B,uni0422,uni042A,uni0462,uni04A0",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "V,uni0474",
    k: 20
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "W,Wcircumflex,Wgrave,Wacute,Wdieresis",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "R,Racute,Rcommaaccent,Rcaron",
    g2: "Y,Yacute,Ycircumflex,Ydieresis,uni03A5,uni03AB,uni04AE,Ygrave,uni038E.calt,uni03A5.calt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    g2: "zero.den,one.den,one.den_alt,two.den,three.den,four.den,five.den,six.den,seven.den,eight.den,nine.den",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "zero.inf,one.inf,two.inf,three.inf,four.inf,five.inf,six.inf,seven.inf,eight.inf,nine.inf,one.inf_alt",
    g2: "zero.inf,one.inf,two.inf,three.inf,four.inf,five.inf,six.inf,seven.inf,eight.inf,nine.inf,one.inf_alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "two.sup,three.sup,one.sup,zero.sup,four.sup,five.sup,six.sup,seven.sup,eight.sup,nine.sup,one.sup_alt",
    g2: "two.sup,three.sup,one.sup,zero.sup,four.sup,five.sup,six.sup,seven.sup,eight.sup,nine.sup,one.sup_alt",
    k: 25
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron",
    g2: "quoteright,quotedblright",
    k: -3
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron",
    g2: "schwa,uni04D9",
    k: 4
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "t,tcommaaccent,tcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "d,g,q,dcaron,dcroat,gbreve,gdotaccent,gcommaaccent,uni03AC,uni03B1,a.alt,uni0434.bgr,aacute.alt,abreve.alt,acircumflex.alt,adieresis.alt,agrave.alt,amacron.alt,aogonek.alt,aring.alt,aringacute.alt,atilde.alt",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "c,e,o,ccedilla,egrave,eacute,ecircumflex,edieresis,eth,ograve,oacute,ocircumflex,otilde,odieresis,oslash,cacute,cdotaccent,ccaron,emacron,ebreve,edotaccent,eogonek,ecaron,omacron,obreve,ohungarumlaut,oe,oslashacute,uni03B4,uni03BF,uni03C2,uni03C3,uni03C6,uni03CC,uni0435,uni043E,uni0441,uni0444,uni0450,uni0451,uni0454,uni0473,uni04AB,uni04D7,uni04E7,uni04E9,uni0431.srb",
    k: 15
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "schwa,uni04D9",
    k: 10
  }), /*#__PURE__*/React.createElement("hkern", {
    g1: "z,zacute,zdotaccent,zcaron",
    g2: "guillemotleft,guilsinglleft",
    k: 15
  })))));
}

export default __webpack_public_path__ + "static/Gotham-Book.f3a08a98.svg";
export { SvgGothamBook as ReactComponent };